import { ReactElement } from 'react'

type SearchNoResultsProps = {
  label?: string
}

export function SearchNoResults({ label = '' }: SearchNoResultsProps): ReactElement {
  return (
    <div className="saas-search-results__no-results">
      <h3>{label}</h3>
    </div>
  )
}
